module.exports = __webpack_public_path__ + "static/tradee_img3-16193e87fc4cb700853fdc4098425524.png";